module.exports = __webpack_public_path__ + "img/etiqueta.156f8cf5.png";